module.exports = __webpack_public_path__ + "img/audit_slowmist_cn.51b09f8f.png";